<template>
  <div id="all-files-history">
    <ipub-model :title="'File History'"
                width="1150px"
                :visable="isVisable"
                :showFooter="false"
                @cancel="cancel">
      <div class="ipub-p2">
        <ipub-table :columns="columns"
                    border
                    :pagination="pagination"
                    :dataSource="dataSource">
          <template v-slot:version="{text}">
            V{{text}}
          </template>
          <template v-slot:source="{text}">
            {{FILE_RESOURCE[text]}}
          </template>
          <template v-slot:name="{text}">
            <ipub-tooltip placement="bottomLeft"
                          style="width:100%"
                          class="mar-l-10">
              <div slot="title">
                {{text.firstName}} {{text.lastName}}({{text.email}})
              </div>
              <div class="omis">
                {{text.firstName}} {{text.lastName}}({{text.email}})
              </div>
            </ipub-tooltip>
            <!-- <div>
              {{text.firstName}} {{text.lastName}}({{text.email}})
            </div> -->
          </template>
          <template v-slot:file="{record}">
            <ipub-tooltip placement="bottomLeft"
                          style="width:100%"
                          class="mar-l-10 link-color ipub-c-p">
              <div slot="title">
                {{record.name}}
              </div>
              <div class="omis">
                <a target="_blank"
                   @click="download(`${domain}/${record.path}`, record.name)"
                   class="link-color omis">{{record.name}}</a>
              </div>
            </ipub-tooltip>
          </template>
          <template v-slot:size="{text}">
            {{text? Number(((text / 1024)/1024)+0.1).toFixed(1)+'MB': '--'}}
          </template>
        </ipub-table>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import mfile from '@/api/mfile'
import help from '@/utils/help'
import { FILE_RESOURCE } from '@/utils/dict'

const columns = [
  {
    title: '',
    enTitle: 'Version',
    width: 80,
    dataIndex: 'sign',
    slot: 'version'
  },
  {
    title: '',
    enTitle: 'Source',
    width: 200,
    dataIndex: 'originType',
    slot: 'source'
  },
  {
    title: '',
    enTitle: 'File Name',
    width: 200,
    dataIndex: 'name',
    slot: 'file'
  },
  {
    title: '',
    enTitle: 'Size',
    width: 80,
    dataIndex: 'size',
    slot: 'size'
  },
  {
    title: '',
    enTitle: 'Date',
    width: 150,
    dataIndex: 'createTime',
    slot: 'time'
  },
  {
    title: '',
    enTitle: 'Operator',
    width: 200,
    dataIndex: 'operator',
    slot: 'name'
  }
]
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      FILE_RESOURCE,
      columns,
      dataSource: [],
      pagination: {
        total: 0,
        size: 10,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      },
      download: help.download
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      country: 'getCountry',
      reviewRefuse: 'getReviewRefuse',
      publisherInfo: 'getPublisherInfo',
      domain: 'getDomain'

    })
  },
  watch: {
    isVisable (val) {
      if (val) {
        this.getList()
      }
    }
  },
  mounted () {
  },
  methods: {
    async getList (page = 1) {
      const { id } = this.inputData
      const data = {
        pageIndex: page,
        pageSize: this.pagination.size
      }

      const { list, pageIndex, pageSize, total } = await mfile.allHistory(id, data)
      this.dataSource = list
      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
    },
    async confirm () {
      this.$emit('confirm', this.selectdList)
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
.color-label {
  color: $content_color;
}
</style>
